import React from 'react'
import { Button, message } from 'antd'
import { VIEW_ARCHIVED_LABEL, archivedToast } from './wording'

const ARCHIVED_TOAST_KEY = 'multiplier-archived'

/** `onViewArchived` adds a link to the archived list; the toast is outside the router, so it can't be a `Link` */
export const showArchivedToast = (
  name: string,
  onViewArchived?: () => void
) => {
  const content = onViewArchived ? (
    <>
      {archivedToast(name)}
      <Button
        type='link'
        size='small'
        onClick={() => {
          message.destroy(ARCHIVED_TOAST_KEY)
          onViewArchived()
        }}
      >
        {VIEW_ARCHIVED_LABEL}
      </Button>
    </>
  ) : (
    archivedToast(name)
  )
  message.success({ content, key: ARCHIVED_TOAST_KEY })
}
